/**
 * Unit marketing (iframe) translations.
 *
 * Powers the standalone `/iframe/properties/:propertyId/units/:unitId/marketing` page,
 * intended to be embedded in a Building Stack modal for editing a unit's
 * marketing-facing configuration (availability, marketing status, website/listing
 * visibility).
 */

export const unitMarketingEn = {
  unitMarketing: {
    fields: {
      availability: 'Unit availability for marketing',
      availabilityDate: 'Date Available',
      marketingStatus: 'Unit marketing status',
      includeOnWebsites: 'Include unit on connected websites',
      includeOnListingSites: 'Include unit on connected listing sites',
    },
    availabilityOptions: {
      available: 'Available',
      availableOnDate: 'Available on Date',
      unavailable: 'Unavailable',
      waitlistOnly: 'Waiting List Only',
    },
    helper: {
      availabilityEnable: 'This setting will allow your unit to be listed on connected websites and listing sites.',
      listingsDisabledFpn: 'Disabled because there are active Floorplan Navigators syndicating to eligible listing sites.',
    },
    banners: {
      lastUnitPromoted: 'This property has an active promoted listing and this is the last available unit. You will not be able to make the unit unavailable or exclude it from listings until the promoted listing is managed.',
      lastUnitSyndicated: 'This is the only unit on {property} that is currently being syndicated. Excluding this unit will prevent the property from being syndicated on associated Rental Listing Sites.',
    },
  },
} as const;

export const unitMarketingFr = {
  unitMarketing: {
    fields: {
      availability: 'Disponibilité de l’unité pour le marketing',
      availabilityDate: 'Date de disponibilité',
      marketingStatus: 'Statut de marketing de l’unité',
      includeOnWebsites: 'Inclure l’unité sur les sites Web connectés',
      includeOnListingSites: 'Inclure l’unité sur les sites d’annonces connectés',
    },
    availabilityOptions: {
      available: 'Disponible',
      availableOnDate: 'Disponible à une date',
      unavailable: 'Non disponible',
      waitlistOnly: 'Liste d’attente seulement',
    },
    helper: {
      availabilityEnable: 'Ce paramètre permettra à votre unité d’être publiée sur les sites Web connectés et les sites d’annonces.',
      listingsDisabledFpn: 'Désactivé, car des Floorplan Navigators actifs diffusent vers des sites d’annonces admissibles.',
    },
    banners: {
      lastUnitPromoted: 'Cette propriété possède une annonce promue active et il s’agit de la dernière unité disponible. Vous ne pourrez pas rendre l’unité indisponible ou l’exclure des annonces tant que l’annonce promue n’aura pas été gérée.',
      lastUnitSyndicated: 'Il s’agit de la seule unité sur {property} actuellement diffusée. Exclure cette unité empêchera la propriété d’être diffusée sur les sites d’annonces locatives associés.',
    },
  },
} as const;
